import { Message } from "element-ui";
import matchtitle from "../components/matchtitle.vue";
import { handlePageQueryTeams } from "@index/api/mymatchs/teammanage";
import { openDialog } from "../../../../../components/fn-dialog";
import OptShow from "./opt-show.vue";
export default {
  components: {
    matchtitle,
  },
  name: "opt-matchs",
  data() {
    return {
      pageSizeTeam: 30,
      currPageTeam: 1,
      totalCountTeam: 0,
      tableDataTeam: [],
      queryFormTeam: {
        name: "",
      },
      countPlayers: 0,
      countGroups: 0,
      sumSignupFee: 0,
      havAuth: false,
      matchId: sessionStorage.getItem("currMatchId"),
      loading: false,
    };
  },
  created() {
    this.pageQueryTeam();
  },
  methods: {
    initAuth(havAuth) {
      this.havAuth = havAuth;
      this.havAuth = true;
    },
    handleSizeChangeTeam(pageSize) {
      //改变页面大小
      this.pageSizeTeam = pageSize;
      this.pageQueryTeam();
    },
    handleCurrentChangeTeam(currPage) {
      //跳转到某一页
      this.currPageTeam = currPage;
      this.pageQueryTeam();
    },
    fastQueryTeam() {
      this.currPageTeam = 1;
      this.pageQueryTeam();
    },
    pageQueryTeam() {
      handlePageQueryTeams({
        pageSize: this.pageSizeTeam,
        currPage: this.currPageTeam,
        name: this.queryFormTeam.name,
        matchId: this.matchId,
        queryAllTeamFlag:1
      }).then((res) => {
        if (res.status == 200) {
          this.tableDataTeam = res.data;
          this.currPageTeam = res.currPage;
          this.pageSizeTeam = res.pageSize;
          this.totalCountTeam = res.totalCount;
          this.countPlayers = res.extendData.countPlayers;
          this.countGroups = res.extendData.countGroups;
          this.sumSignupFee = res.extendData.sumSignupFee;
        } else {
          Message({
            message: res.msg,
            type: "error",
            duration: 5 * 1000,
          });
        }
      });
    },
    setShow(row) {
      const options = {
        title: "修改显示权限",
        width: "240px",
        isFooter: true,
        confirmText: "确定",
        cancelText: "取消",
        params: row,
        callback: () => {
          this.pageQueryTeam();
        },
      };
      openDialog(OptShow, options);
    },
  },
};
